import { useTranslation } from 'react-i18next';

export default function JoinEnded() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-sm">
        <h1 className="mb-2 text-2xl font-bold text-gray-900">
          {t('appointments.detail.guestEnded.title')}
        </h1>
        <p className="text-gray-600">
          {t('appointments.detail.guestEnded.description')}
        </p>
      </div>
    </div>
  );
}
